import { render, staticRenderFns } from "./TravelServiceOrderItemRailChip.vue?vue&type=template&id=b1f2f060&scoped=true&"
import script from "./TravelServiceOrderItemRailChip.vue?vue&type=script&lang=js&"
export * from "./TravelServiceOrderItemRailChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f2f060",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VIcon,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1f2f060')) {
      api.createRecord('b1f2f060', component.options)
    } else {
      api.reload('b1f2f060', component.options)
    }
    module.hot.accept("./TravelServiceOrderItemRailChip.vue?vue&type=template&id=b1f2f060&scoped=true&", function () {
      api.rerender('b1f2f060', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TravelService/Chips/TravelServiceOrderItemRailChip.vue"
export default component.exports